import { handleApiGet, handleApiPut, definedRouteTypes } from "./api";
import { getSingleData, postData, updateData } from "./DynamicApi";
import { BackendUrl } from "./newBackendApi";

import { IOrganizationForm } from ".";

export function getSingleOrganization(slug: string) {
  return getSingleData(definedRouteTypes.organizations, slug);
}

export function postOrganizations(idToken: string, body: IOrganizationForm) {
  return postData(idToken, definedRouteTypes.organizations, body);
}

export function updateOrganizations(
  idToken: string,
  body: Partial<IOrganizationForm>,
) {
  return updateData(idToken, definedRouteTypes.organizations, body);
}

export function getOrganizationUrls() {
  return handleApiGet(`${BackendUrl}/get-item/org-slugs`);
}

export function putOrganizationUrls(
  idToken: string,
  items: { name: string; pseudonym: string }[],
) {
  return handleApiPut(`${BackendUrl}/admin/put-item/org-slugs`, idToken, {
    items,
  });
}
